import { UnitType } from "./UnitType";
import { House } from "./House";
import { Castle } from "./Castle";
import { Tower } from "./Tower";
import { Chapel } from "./Chapel";
import { Shrine } from "./Shrine";
import { Peasant } from "./Peasant";
import { Knight } from "./Knight";
import { Priest } from "./Priest";
import { Cauldron } from "./Cauldron";
import { Seat } from "./Seat";
import { Fiend } from "./Fiend";
import { Imp } from "./Imp";
import { Demon } from "./Demon";
import { Cultist } from "./Cultist";
import { Pentagram } from "./Pentagram";
import { Machine } from "./Machine";
import { Obelisk } from "./Obelisk";
import { FireRain } from "./FireRain";
import { ConversionRitual } from "./ConversionRitual";
import { UnitRegistry } from "../types";

export * from "./context";
export { UnitType } from "./UnitType";
export { SpawnerBuilding } from "./SpawnerBuilding";
export {
    House, Castle, Tower, Chapel, Shrine, Peasant, Knight, Priest,
    Cauldron, Seat, Fiend, Imp, Demon, Cultist, Pentagram, Machine, Obelisk, FireRain, ConversionRitual
};

export const unitRegistry: UnitRegistry = {
    "house": new House(),
    "castle": new Castle(),
    "tower": new Tower(),
    "chapel": new Chapel(),
    "shrine": new Shrine(),
    "peasant": new Peasant(),
    "knight": new Knight(),
    "priest": new Priest(),
    "cauldron": new Cauldron(),
    "seat": new Seat(),
    "fiend": new Fiend(),
    "imp": new Imp(),
    "demon": new Demon(),
    "cultist": new Cultist(),
    "pentagram": new Pentagram(),
    "machine": new Machine(),
    "obelisk": new Obelisk(),
    "fire rain": new FireRain(),
    "conversion ritual": new ConversionRitual(),
};
